import adminRoutes from '@/routes/admin';

import AdminMainWrapper from '@/admin/layout/AdminMainWrapper.vue';

const routes = [
  {
    path: '/',
    // name: 'AdminBase',
    component: AdminMainWrapper,
    children: adminRoutes,
  },
  // {
  //   path: '/',
  //   // name: 'StoreBase',
  //   component: StoreMainWrapper,
  //   children: storeRoutes,
  // },
];

export default routes;
